var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 21h-1.25a19.867 19.867 0 0 0-3.668-8.84l.889-.888a3 3 0 1 0-4.242-4.243l-.89.889A19.868 19.868 0 0 0 27 4.25V3a3 3 0 0 0-6 0v1.25a19.868 19.868 0 0 0-8.84 3.668l-.888-.889a3 3 0 1 0-4.243 4.243l.889.889A19.867 19.867 0 0 0 4.25 21H3a3 3 0 0 0 0 6h1.25a19.867 19.867 0 0 0 3.668 8.84l-.889.888a3 3 0 0 0 4.242 4.243l.89-.889A19.868 19.868 0 0 0 21 43.75V45a3 3 0 0 0 6 0v-1.25a19.868 19.868 0 0 0 8.84-3.668l.888.889a3 3 0 1 0 4.243-4.243l-.889-.889A19.867 19.867 0 0 0 43.75 27H45a3 3 0 0 0 0-6zM24 38a14 14 0 1 1 14-14 14.016 14.016 0 0 1-14 14z",
    "data-name": "Layer 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.aa031edb7b043272f1a25fbbcb211205.svg";
export { ForwardRef as ReactComponent };